import React from 'react';
import { Icons } from '../../components/Icon.jsx';

const PrefabsTab = ({
  prefabs,
  selectedPrefabId,
  searchTerm,
  editingPrefabId,
  editingName,
  onSearchChange,
  onPrefabSelect,
  onPrefabDoubleClick,
  onPrefabRename,
  onPrefabDelete,
  onEditNameChange,
  onEditNameBlur,
  onEditNameKeyDown,
  onPrefabDragStart,
  onPrefabDragEnd
}) => {
  const visiblePrefabs = prefabs.filter(p =>
    p.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="flex flex-col h-full">
      {/* Search & Actions */}
      <div className="p-2 border-b border-admin_bordered bg-admin_canvas flex gap-2">
        <div className="relative flex-1">
          <Icons.Search className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400 w-3 h-3" />
          <input
            className="w-full bg-admin_paper border border-admin_bordered rounded pl-7 pr-2 py-1 text-xs outline-none focus:border-blue-500 transition-all text-admin_text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
        <button
          className={`p-1.5 rounded border ${
            selectedPrefabId
              ? 'bg-red-50 text-red-500 border-red-200 hover:bg-red-100'
              : 'bg-gray-50 text-gray-300 border-gray-100 cursor-not-allowed'
          }`}
          onClick={() => selectedPrefabId && onPrefabDelete(selectedPrefabId)}
          disabled={!selectedPrefabId}
          title="Delete Selected Prefab"
        >
          <Icons.Trash className="w-3.5 h-3.5" />
        </button>
      </div>

      <div className="p-4 flex-1 overflow-y-auto">
        <h2 className="text-xs font-semibold text-gray-400 mb-4 uppercase tracking-wider">
          Library
        </h2>
        {visiblePrefabs.length === 0 ? (
          <div className="text-xs text-gray-500 text-center italic py-4">
            No prefabs found.
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-2">
            {visiblePrefabs.map((p) => (
              <div
                key={p.id}
                draggable
                onDragStart={(e) => {
                  e.dataTransfer.setData('prefabId', p.id);

                  // Hide the default drag image completely
                  const emptyImg = document.createElement('div');
                  emptyImg.style.opacity = '0';
                  emptyImg.style.position = 'absolute';
                  emptyImg.style.top = '-1000px';
                  document.body.appendChild(emptyImg);
                  e.dataTransfer.setDragImage(emptyImg, 0, 0);
                  setTimeout(() => document.body.removeChild(emptyImg), 0);

                  onPrefabDragStart?.(p.id);
                }}
                onDragEnd={() => {
                  onPrefabDragEnd?.(p.id);
                }}
                onClick={() => onPrefabSelect(p.id)}
                onDoubleClick={(e) => onPrefabDoubleClick(e, p.id)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && selectedPrefabId === p.id && editingPrefabId !== p.id) {
                    e.preventDefault();
                    onPrefabRename(p.id, p.name);
                  }
                }}
                tabIndex={0}
                className={`flex flex-row items-center gap-3 p-2 border shadow-sm rounded cursor-pointer transition-all group relative
                  ${
                    selectedPrefabId === p.id
                      ? 'bg-blue-100 border-blue-500 ring-1 ring-blue-500'
                      : 'bg-blue-50 border-blue-100 hover:border-blue-300 hover:bg-blue-100'
                  }
                `}
              >
                <Icons.BoxSelect
                  className={`w-4 h-4 flex-shrink-0 ${
                    selectedPrefabId === p.id ? 'text-blue-700' : 'text-blue-500'
                  }`}
                />
                {editingPrefabId === p.id ? (
                  <input
                    autoFocus
                    className="flex-1 min-w-0 text-xs px-1 py-0.5 border rounded outline-none"
                    value={editingName}
                    onChange={onEditNameChange}
                    onBlur={onEditNameBlur}
                    onKeyDown={onEditNameKeyDown}
                    onClick={(e) => e.stopPropagation()}
                  />
                ) : (
                  <span
                    className={`text-xs truncate flex-1 ${
                      selectedPrefabId === p.id
                        ? 'text-blue-900 font-bold'
                        : 'text-blue-900'
                    }`}
                  >
                    {p.name}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PrefabsTab;
